import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LenguageRoutingModule } from './lenguage-routing.module';
import { LenguageComponent } from './lenguage/lenguage.component';
import {MDBBootstrapModule} from 'angular-bootstrap-md/index';
import {ApiService} from '../shared/services/api.service';
import {LenguageService} from '../shared/services/lenguage.service';
import {InvestigadoresService} from '../shared/services/investigadores.service';
import {StaticLenguageService} from '../shared/services/static-lenguage.service';
import {RouterModule} from '@angular/router';
import {SharedModule} from "../shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
      SharedModule,
    LenguageRoutingModule,
    MDBBootstrapModule.forRoot()
  ],
  declarations: [LenguageComponent],
  exports: [ RouterModule, LenguageComponent],
  // todos los servicios para que queden dentro del mismo injector dado por este modulo 'padre'.
  providers: [ApiService, LenguageService, InvestigadoresService, StaticLenguageService]
})
export class LenguageModule { }



// WEBPACK FOOTER //
// ./src/app/lenguage/lenguage.module.ts